import React from 'react'
import { Breadcrumb } from 'antd';
import { connect } from "react-redux";
import actionWays from '../../../redux/actions.js';
import Top from '../Top'
import Footer from '../Footer.js'
import './requestFlow.scss'
class RequestFlow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabData: [],
            loading: false,
            rawHTML: '',
            rightTitle: '',
            downLoadList: [],
        }
    }
    componentDidMount() {
        this.setState({
            loading: true,
        })
    }
    render() {
        const { loading } = this.state;
        return (
            <div id={'requestFlow'} style={{ background: '#fff' }}>
                <Top />
                {loading ? <div>
                    <div className='requestProblem_top'></div>
                    <div className="col-lg-3"></div>
                    <div className="col-lg-6">
                        <div style={{ paddingLeft: '7px', margin: '1em 0' }}>
                            <Breadcrumb separator=">">
                                <Breadcrumb.Item>首页</Breadcrumb.Item>
                                <Breadcrumb.Item>申请流程</Breadcrumb.Item>
                            </Breadcrumb>
                        </div>
                        <div className='requestProblem_box'>
                            <img
                                src={require('../../../assets/images/requestFlow-bg.jpg').default}
                            ></img>
                        </div>
                    </div>
                    <div className="col-lg-3"></div>
                    <Footer />
                </div> : ''}
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        userLoginInfo: state.userLoginInfo,
    }
};
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(RequestFlow)
